<template>
    <div>
        <div class="model" style="margin-top: 0.32rem;">
            <p class="model_title top">粉丝量{{ fansSummary.all }}人</p>
            <div class="flex dateDetail">
                <p>今日：{{ fansSummary.day }}</p>
                <p>本周：{{ fansSummary.week }}</p>
                <p>本月：{{ fansSummary.month }}</p>
            </div>
            <div class="select">
                <div class="label">
                    <p :class="fansBy === 'day' ? 'selected' : ''" @click="() => selectFansByWay('day')">
                        按天
                    </p>
                    <p :class="fansBy === 'week' ? 'selected' : ''" @click="() => selectFansByWay('week')">
                        按周
                    </p>
                    <p :class="fansBy === 'month' ? 'selected' : ''" @click="() => selectFansByWay('month')">
                        按月
                    </p>
                </div>
            </div>
            <!-- 报表 -->
            <div v-if="ifInit" class="flex model_body flex">
                <div class="data-table flex1" id="channel"></div>
            </div>
        </div>
        <!-- 表格 -->
        <div class="model">
            <mt-tab-container>
                <mt-tab-container-item>
                    <ul>
                        <li class="flex nav-title">
                            <div class="flex1 skyBlue fans">粉丝</div>
                            <div class="flex1 skyBlue">来源</div>
                            <div class="flex1 waterBlue">锁粉时间</div>
                        </li>
                        <li class="flex nav-title line" v-for="(item, index) in fansList.fans" :key="index">
                            <div class="flex1 imageContainer">
                                <img :src="item.user.headUrl || '../../../static/img/default.png'" alt="" class="avatar">
                                <div class="user-info">
                                    <span>{{item.user.nick}}</span>
                                    <span>{{item.user.memberNo}}</span>
                                </div>
                            </div>

                            <!-- 接口还没想好 -->
                            <!-- <div class="flex1">{{ item.createDate }}</div> -->
                            <div class="flex1">{{
                                item.refererChannelKey ?
                                fansList.inviteCodes.find(s => s.channelKey === item.refererChannelKey).name :
                                item.refererUserId ?
                                fansList.users.find(s => s.id === item.refererUserId).nick :
                                '平台流量'
                                }}</div>
                            <div class="flex1">{{ dateFormat(item.createDate) }}</div>
                        </li>
                    </ul>
                </mt-tab-container-item>
            </mt-tab-container>
        </div>
        <div v-if="fansList.fans.length === 0" class="empty">
            <img src="../../../static/img/empty.svg" alt="">
            <p class='nodata'>暂无更多信息</p>
        </div>
    </div>
</template>

<script>
import 'echarts/lib/chart/line';
import { formateDay } from '../../utils/utils';

export default {
  props: [
    'fansSummary',
    'fans',
    'fansList',
    'fansBy',
    'selectFansBy',
    'nexusRetailLevelUsers',
    'nexusRetailLevelOverview',
    'memberScoreType',
  ],
  name: 'FansTable',
  data() {
    return {
      ifInit: true,
    };
  },
  watch: {
    fans: {
      handler: function(val, oldVal) {
        if (JSON.stringify(val) !== JSON.stringify(oldVal)) {
          this.init();
        }
      },
      deep: true,
    },
  },
  mounted() {
    const self = this;
    setTimeout(() => {
      self.init();
    }, 1000);
    // this.init();
  },
  methods: {
    selectFansByWay: function(value) {
      this.selectFansBy(value);
      this.$store.dispatch('user/getFans', value);
    },
    dateFormat: function(timestamp) {
      return formateDay(timestamp);
    },
    init: function() {
      const container = document.getElementById('channel');
      let myEcharts = this.$echarts.init(container);
      let option = {
        color: '#ccc',
        width: '85%',
        title: {
          text: '',
        },
        tooltip: {},
        grid: {
          x: 30,
          y: 30,
        },
        xAxis: {
          data: this.fans.axis,
          axisLine: {
            lineStyle: {
              color: '#00BCD4',
              width: 1,
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: '#7F7F7F',
          },
        },
        yAxis: {
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        series: [
          {
            name: '流量',
            type: 'line',
            data: this.fans.value,
            itemStyle: {
              normal: {
                color: function(params) {
                  var colorList = ['#334B5C', '#D53A35', '#7FAE90', '#9FDABF'];
                  return colorList[(params.dataIndex + 1) % 4];
                },
              },
            },
          },
        ],
      };
      myEcharts.setOption(option);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.top {
  padding-top: 0.15rem;
  padding-left: 0.3rem;
}
.dateDetail {
  text-align: center;
  justify-content: space-around;
  padding: 0.1rem 0;
}
.dateDetail p {
  color: #7f7f7f;
}
.label {
  display: flex;
  float: right;
  padding-right: 0.3rem;
}
.label p {
  padding: 0.02rem 0.1rem;
  color: #009688;
  border: 1px solid #009688;
}
.label p:nth-child(1) {
  border-right: none !important;
  border-radius: 0.05rem 0 0 0.05rem;
}
.label p:nth-child(3) {
  border-left: none !important;
  border-radius: 0 0.05rem 0.05rem 0;
}
.selected {
  color: #fff !important;
  background: #009688;
}
ul {
  padding-left: 0px;
  text-align: center;
  margin-top: 0;
  font-size: 0.13rem;
  background: #fff;
}

.flex1 {
  line-height: 0.4rem;
}
.data-table {
  height: 2.23rem;
  width: 3.2rem;
}
.model {
  height: unset;
}
.select {
  overflow: hidden;
}
.flex1 {
  overflow: hidden;
  white-space: nowrap;
}
.line {
  border-bottom: 0.3px solid #d8d8d8;
}
/* .model {
    height: unset;
} */
ul {
  margin-bottom: 0;
}
.left {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.empty {
  text-align: center;
  margin-top: 1.06rem;
}
.imageContainer {
  padding-left: 0.05rem;
}
.avatar {
  position: relative;
  width: 0.25rem;
  height: 0.25rem;
  border-radius: 50%;
  top: 0.1rem;
}
.user-info {
  display: inline-block;
  margin-left: 0.06rem;
  line-height: 1;
  vertical-align: middle;
  width: 0.6rem;
  text-align: left;
}
.user-info > span {
  display: block;
  line-height: 0.15rem;
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
  .text-align-left {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/userMemberElement/FansTable.vue